<template>
  <v-dialog v-model="dialog" persistent max-width="850px">
    <v-card>
      <!--TITLE-->
      <v-card-title class="redColor text-white">
        <span v-if="edit == true" class="headline">{{
          $t("repositories.form.edit_repository")
        }}</span>
        <span v-if="edit == false" class="headline">{{
          $t("repositories.form.create_repository")
        }}</span>
      </v-card-title>
      <v-card-text>
        <!--FORM-->
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-container grid-list-md>
            <v-row wrap>
              <!--NOT EMPTY ALERT-->
              <v-col v-if="isEmpty === false" xs="6" md="6" lg="6">
                <v-spacer />
              </v-col>
              <v-col v-if="isEmpty === false" xs="6" md="6" lg="6">
                <h4 class="red--text">
                  {{ $t("repositories.form.not_empty") }}
                </h4>
              </v-col>

              <!--REPOSITORY NAME-->
              <v-col cols="12" xs="12" md="12" lg="12">
                <v-text-field
                  v-model="repository.name"
                  :rules="rules.required"
                  :label="$t('repositories.form.name')"
                  color="red-darken-1"
                  variant="solo"
                />
              </v-col>

              <!--SELECT INSTITUTION-->
              <v-col
                v-if="
                  $store.getters.role == 'LekoAdmin' ||
                  $store.getters.role == 'LekoEmployee' ||
                  $store.getters.role == 'SuperAdmin'
                "
                 cols="12"
                xs="12"
                md="12"
                lg="12"
              >
                <v-select
                  v-model="repository.institution_id"
                  :loading="loadingInstitutions"
                  :rules="rules.required"
                  :items="institutions"
                  :label="$t('repositories.form.select_institution')"
                  color="red-darken-1"
                  item-title="title"
                  item-value="_id"
                  variant="solo"
                />
              </v-col>

              <!--ROOMS-->
              <v-col  cols="12" xs="12" md="12" lg="12">
                <!--ADD ROOM-->
                <v-text-field
                  v-model="roomTitle"
                  :label="$t('repositories.form.rooms')"
                  color="red-darken-1"
                  append-icon="mdi-plus-circle-outline"
                  variant="solo"
                  @click:append="addRoom"
                />

                <!--ROOM LIST-->
                <v-list>
                  <v-list-item v-for="(room, index) in rooms" :key="index">
                    <v-row
                      class="pt-0 pb-0 justify-center border pl-2 mt-4 align-center"
                      no-gutters
                    >
                      <!-- SELECTION RADIO -->
                      <v-col cols="auto">
                        <v-radio-group
                          v-model="selectedRoomIndex"
                          hide-details
                          @change="selectRoom(index)"
                        >
                          <v-radio
                            :value="index"
                            color="primary"
                            density="compact"
                          />
                        </v-radio-group>
                      </v-col>

                      <!-- ROOM TITLE -->
                      <v-col class="d-flex align-center">
                        <v-list-item-title>{{ room.name }}</v-list-item-title>
                      </v-col>

                      <!-- REMOVE BUTTON -->
                      <v-col cols="auto">
                        <v-btn
                          icon
                          variant="text"
                          @click.stop="confirmRemoveRoom(index)"
                        >
                          <v-icon color="grey-darken-2"
                            >mdi-minus-circle-outline</v-icon
                          >
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-list-item>
                </v-list>
                <!--ROOM SELECTION ALERT-->
                <span v-if="!room" class="body-1 error--text">
                  {{ $t("repositories.select_room") }}
                </span>
              </v-col>

              <!--LOCATIONS-->
              <v-col v-if="room"  cols="12" xs="12" md="12" lg="12">
                <!--ADD LOCATION-->
                <v-row row>
                  <v-col  cols="6" xs="4" md="4" lg="4">
                    <!--POSITION X-->
                    <v-text-field
                      v-model="location.position_x"
                      :label="$t('repositories.form.position_x')"
                      color="red-darken-1"
                      type="number"
                      min="1"
                      oninput="validity.valid || (value = '')"
                    />
                  </v-col>
                  <v-col  cols="6" xs="4" md="4" lg="4">
                    <!--POSITION Y-->
                    <v-text-field
                      v-model="location.position_y"
                      :label="$t('repositories.form.position_y')"
                      color="red-darken-1"
                      type="number"
                      min="1"
                      oninput="validity.valid || (value = '')"
                    />
                  </v-col>
                  <v-col  cols="6" xs="4" md="4" lg="4">
                    <!--CODE-->
                    <v-text-field
                      v-model="location.code"
                      :label="$t('repositories.form.code')"
                      color="red-darken-1"
                    />
                  </v-col>
                </v-row>
                <!--NOTES-->
                <v-text-field
                  v-model="location.notes"
                  :label="$t('repositories.form.notes')"
                  color="red-darken-1"
                />
                <!--SAVE BUTTON-->
                <v-col xs="12" md="12" lg="12">
                  <v-row justify-center>
                    <v-btn
                      variant="outlined"
                      :disabled="
                        !location.position_x ||
                        !location.position_y ||
                        !location.code
                      "
                      color="primary"
                      @click="addLocation()"
                    >
                      {{ $t("repositories.form.save_location") }}
                    </v-btn>
                  </v-row>
                </v-col>

                <!--LOCATIONS LIST-->
                <v-list>
                  <v-list-item
                    v-for="(location, index) in room.locations"
                    :key="index"
                    class="py-2"
                  >
                    <!-- LIST DETAILS -->
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ $t("repositories.form.code") }}: {{ location.code }}
                      </v-list-item-title>

                      <v-list-item-subtitle class="text-primary">
                        {{ $t("repositories.form.position_x") }}:
                        {{ location.position_x }},
                        {{ $t("repositories.form.position_y") }}:
                        {{ location.position_y }}
                      </v-list-item-subtitle>

                      <v-list-item-subtitle>
                        {{ $t("repositories.form.notes") }}:
                        {{ location.notes }}
                      </v-list-item-subtitle>
                    </v-list-item-content>

                    <!-- ACTION BUTTONS -->
                    <template #append>
                      <v-row class="justify-end align-center pr-2" no-gutters>
                        <!-- EDIT BUTTON -->
                        <v-btn
                          icon
                          variant="text"
                          :ripple="false"
                          :disabled="!edit || !location._id"
                          density="compact"
                          @click.stop="editLocation(location)"
                        >
                          <v-icon color="grey-darken-2">mdi-pencil</v-icon>
                        </v-btn>

                        <!-- REMOVE BUTTON -->
                        <v-btn
                          icon
                          variant="text"
                          :ripple="false"
                          density="compact"
                          @click.stop="confirmRemoveLocation(index)"
                        >
                          <v-icon color="grey-darken-2"
                            >mdi-minus-circle-outline</v-icon
                          >
                        </v-btn>
                      </v-row>
                    </template>
                  </v-list-item>
                </v-list>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>

      <!--ACTION BUTTONS-->
      <v-card-actions>
        <v-spacer />
        <!--CLOSE-->
        <v-btn color="red-darken-1" variant="outlined" @click="close">
          {{ $t("repositories.form.close") }}
        </v-btn>
        <!--SAVE-->
        <v-btn
          :disabled="!valid"
          :loading="loading"
          color="green-darken-1"
          variant="outlined"
          @click="save"
        >
          {{ $t("repositories.form.save") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import getRequest from "../../api/getRequest";
import postRequest from "../../api/postRequest";

export default {
  data: () => ({
    dialog: false,
    valid: false,
    loading: false,
    edit: null,
    rules: {
      required: [(v) => !!v || "Please fill this field"],
    },
    isEmpty: true,
    repository: {},
    loadingInstitutions: false,
    institutions: [],
    rooms: [],
    room: null,
    location: {},
    roomTitle: null,
    selectedRoomIndex: null,
  }),
  watch: {},
  methods: {
    open(edit, repository) {
      if (
        this.$store.getters.role === "LekoEmployee" ||
        this.$store.getters.role === "LekoAdmin" ||
        this.$store.getters.role === "SuperAdmin"
      ) {
        this.getInstitutions();
      }
      this.edit = edit;
      this.repository = repository;
      if (repository.rooms) this.rooms = repository.rooms;
      this.dialog = true;
    },
    close() {
      this.repository = {};
      this.institutions = [];
      for (let i = 0; i < this.rooms.length; i += 1) {
        this.rooms[i].selected = false; // Deselect all rooms.
      }
      this.room = null;
      this.rooms = [];
      this.location = {};
      this.dialog = false;
      this.valid = false;
      this.loading = false;
      this.isEmpty = true;
      this.edit = null;
      this.selectedRoomIndex = null;
      this.$emit("close");
    },
    hide() {
      this.dialog = false;
    },
    show() {
      this.dialog = true;
    },
    save() {
      if (this.$refs.form.validate) {
        this.loading = true;
        this.repository.rooms = this.rooms;
        if (
          this.$store.getters.role === "User" ||
          this.$store.getters.role === "InstitutionManager" ||
          this.$store.getters.role === "InstitutionAdmin" ||
          this.$store.getters.role === "EbayOperator"
        ) {
          this.repository.institution_id = this.$store.getters.institutionId;
        }
        this.loadingDialog = true;
        const formData = new FormData();
        formData.append("data", JSON.stringify(this.repository));
        if (this.edit === true) {
          postRequest
            .formData("/repository/edit", `id=${this.repository._id}`, formData)
            .then((response) => {
              this.close();
              this.$emit("save");
            })
            .catch(() => {
              this.close();
            });
        } else if (this.edit === false) {
          postRequest
            .formData("/repository/new", "", formData)
            .then((response) => {
              this.close();
              this.$emit("save");
            })
            .catch(() => {
              this.close();
            });
        } else {
          this.close();
        }
      }
    },
    addRoom() {
      this.rooms.push({
        selected: false,
        name: this.roomTitle,
        locations: [],
      });
      this.roomTitle = null;
    },
    confirmRemoveRoom(index) {
      this.$emit("remove-room", index);
    },
    removeRoom(index) {
      this.rooms.splice(index, 1);
    },
    selectRoom(index) {
      this.selectedRoomIndex = index; // select this index
      this.room = this.rooms[index];
      if (this.room && !this.room.locations) this.room.locations = [];
      // for (let i = 0; i < this.rooms.length; i += 1) {
      //   this.rooms[i].selected = false; // Deselect all rooms.
      // }
      // this.room = this.rooms[index]; // Set room's data.
      // this.room.index = index; // Save array's index.
      // this.room.selected = true; // Set selected flag.
    },
    addLocation() {
      this.room.locations.push(this.location); // Push newly created location to the room object.
      this.location = {}; // Clear location fields.
      this.rooms[this.room.index] = this.room; // Update room object in the rooms array.
    },
    confirmRemoveLocation(index) {
      this.$emit("remove-location", index);
    },
    removeLocation(index) {
      this.room.locations.splice(index, 1); // Remove location from the room object.
      this.rooms[this.room.index] = this.room; // Update room object in the rooms array.
    },
    editLocation(location) {
      this.$emit("location", {
        location,
        repository: this.repository,
        room: this.room,
      });
    },
    getInstitutions() {
      this.loadingInstitutions = true;
      getRequest("/institution/")
        .then((response) => {
          this.institutions = response.institutions;
          this.loadingInstitutions = false;
        })
        .catch(() => {
          this.loadingInstitutions = false;
        });
    },
  },
};
</script>
